import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
@Injectable({
	providedIn: 'root'
})
export class ContactInformationService {


	constructor(public http: HttpClient) { }

	public getContactDetails(): Observable<any> {
		return this.http.get(environment.BASE_URL_PROFILE + "profile/getContactDetails")
	}
	public saveContacts(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'profile/saveContactDetails', payload)
	}
}
